import { all, takeEvery, put, call } from 'redux-saga/effects'
import { getLogs, getJobConfigs } from 'services/jobs'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_LOGS(action) {
  try {
    const logsData = yield call(getLogs, action.payload)
    if (logsData.ok) {
      yield put({
        type: actions.LOGS_LOAD_SUCCEEDED,
        payload: logsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar logs')
      put({
        type: actions.LOGS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.LOGS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_JOB_CONFIGS() {
  try {
    const result = yield call(getJobConfigs)
    if (result.ok) {
      yield put({
        type: actions.JOB_CONFIGS_LOAD_SUCCEEDED,
        payload: result.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar configuración de jobs')
      yield put({ type: actions.JOB_CONFIGS_LOAD_FAILED })
    }
  } catch (e) {
    yield all([put({ type: actions.JOB_CONFIGS_LOAD_FAILED, error: e.message })])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGS_LOAD_REQUESTED, GET_LOGS),
    takeEvery(actions.JOB_CONFIGS_LOAD_REQUESTED, GET_JOB_CONFIGS),
  ])
}
